import { LanguageTag } from '@vista-digital/ocapi-types/v1';
import { Validator } from '@vista-digital/validator';
import { nonEmptyStringValidator } from './string';
export const translationValidator = Validator.object({
    languageTag: Validator.oneOf(Object.values(LanguageTag)),
    text: nonEmptyStringValidator
});
